import React from 'react';
import {
    Form, Row, Col, Input, Button,
} from 'antd';
import I18n from "../../../language/I18n";
import ModelManager from "../../../domain/ModelManager";
import moment from "moment";
import 'moment/locale/zh-cn';
import QRCode from 'qrcode.react';

const dateFormat = I18n.t("YYYY年MM月DD日");
const dateTimeFormat = I18n.t("YYYY年MM月DD日 HH:mm");
const dateFullFormat = I18n.t("YYYY年MM月DD日 HH:mm:ss");

const Logo = `data:image/png;base64,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`;

const basicInfo = {
    logo: "../../../assets/images/printLogo3.png",
    address: "De’Longhi Experience Store, Shop No.4, 1/F, SOGO Tsim Sha Tsui, 20 Nathan Road, Tsim Sha Tsui, Kowloon.",
    logo1: "De'Longhi Kenwood A.P.A. Ltd.",
    title: "../../../assets/images/printTitle.png",
    titleCN: "產品維修單",
    titleEN: "Repair Order",
    customerCareHotline: "+852 2237-1313",
    officeHoursCN: "星期一至五 09:00-18:00 / 星期六 09:00-13:00",
    officeHoursEN: "Mon to Fri 09:00-18:00 / Sat 09:00-13:00",
    TermsAndCondition: [
        {
            No: 1,
            cn: "顧客須保留及出示購買證明或單據以享有保養及售後服務。(僅限香港特別行政區及澳門特別行政區)",
            en: "Customer is required to present a valid purchase invoice or a receipt when service is requested. (Limited to Hong Kong SAR and Macau SAR)",
        },
        {
            No: 2,
            cn: "任何情況下, 已收取的檢查費不會退還; 亦不會用作抵消零件費用途.",
            en: "In any events, the paid fee is non-refundable; and will not be use as the spare parts cost.",
        },
        {
            No: 3,
            cn: "請在收到通知後 30天內, 攜此單據取件.  逾時而沒有合理原因者, 本公司會把有關貨件銷毀而不作另行通知. ",
            en: "Please collect the repair unit within 30 Days of notification.  It is overtime without reasonable cause, we will dispose the unit without further notification.",
        },
        {
            No: 4,
            cn: "如經檢查後, 証實產品曾被非授權改裝, 包括內部結構或電壓, 或不正當使用情況, 本公司不會提供任何維修服務.",
            en: "The Warranty will be voided, if it is confirmed an unoffical modification, include operation mechanism or electronics, or unsupported usage.",
        },
        {
            No: 5,
            cn: "產品的使用狀況, 以服務員收件時和客人核實為準, 維修站亦會在收件後拍照存檔.  會以有關記錄作依據. ",
            en: "The usage status of the Product will be checked during the collection.  The Repair Center will take photo after receiving the package. It will be used for reference if there is any discrepency occurs.",
        },
        {
            No: 6,
            cn: "維修過程中, De'Longhi 指定維修中心會確保產品為客人提交時的使用狀況.  如有任何因維修而受到影響, 會先致電客人核實.",
            en: "During the maintenance process, De'Longhi's designated maintenance center will ensure that the product is in the state of use when the product is collected.If there is any impact due to maintenance, the customer will be called to verify.",
        },
        {
            No: 7,
            cn: "De'Longhi 指定維修中心為 圖騰控股香港有限公司.",
            en: "De'Longhi's designated repair service provider is Totem Holding (Hong Kong) Co Ltd.",
        },
        {
            No: 8,
            cn: "此維修單內的個人資料將會被De'Longhi HK用於產品推廣及用戶流量調查用途，如不用接收有關推廣信息，請致電2237-1313要求停止使用有關資料。",
            en: " The personal information in this repair order will be used by De'Longhi HK for product promotion and user traffic survey purposes. If you would like to unscubscribe, please call 2237-1313 to update and stop using the relevant information.",
        },
    ],
};

export default class FixAppPrint extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            doc: props.doc,
            basicInfo,
        };
    }
    componentDidMount() {
        this.changeCanvasToPic();
    };

    componentWillUnmount() {
    }

    onDateFormat = (date, format) => {
        if (date) {
            return moment(date).format(format);
        }
        return "";
    };

    goBack = (refresh) => {
        if (this.props.goBack) {
            this.props.goBack(refresh);
        }
    };

    printReport = () => {
        this.setState({ print: true, }, () => {
            this.forceUpdate();
        });
        setTimeout(() => {
            let printHtml = document.getElementById("FixAppPrintForm").innerHTML;
            let wind = window.open("", 'newwindow', 'height=300, width=700, top=100, left=100, toolbar=no, menubar=no, scrollbars=no, resizable=no,location=n o, status=no');
            wind.document.body.innerHTML = printHtml;
            wind.print();
            this.setState({ print: false }, () => {
                this.forceUpdate();
            });
            return false;
        }, 200);
    };

    getPartsMoney = (part) => {
        if (part.price == null || part.amount == null || isNaN(part.price) || isNaN(part.amount)) {
            return NaN;
        }
        return part.price.mul(part.amount);
    };

    PartsMoney = () => {
        let { doc } = this.state;
        doc.partsList = doc.partsList || [];
        // if (doc.partsList.length === 0) {
        //     return null;
        // }
        let total = 0;
        for (let i = 0; i < doc.partsList.length; i++) {
            let p = doc.partsList[i];
            p.partsMoney = this.getPartsMoney(p);
            if (isNaN(p.partsMoney))
                continue;
            total = total.add(p.partsMoney);
        }
        return total.toFixed(2);
    };

    TotalMoney = () => {
        let { doc } = this.state;
        let total = 0;
        if (doc.otherFee) {
            total = total.add(doc.otherFee);
        }
        if (doc.noGuarantee || doc.warranty === 2) {
            if (doc.fixFee) {
                total = total.add(doc.fixFee);
            }
            doc.partsList = doc.partsList || [];
            // if (doc.partsList.length === 0) {
            //     return null;
            // }
            for (let i = 0; i < doc.partsList.length; i++) {
                let p = doc.partsList[i];
                p.partsMoney = this.getPartsMoney(p);
                if (isNaN(p.partsMoney))
                    continue;
                total = total.add(p.partsMoney);
            }
        }
        return total.toFixed(2);
    };

    setCount = (value) => {
        if (value == null) {
            return value;
        }
        return value.toFixed(2);
    };

    changeCanvasToPic = () => {
        const canvasImg = document.getElementById("qrCode"); // 获取canvas类型的二维码
        const img = new Image();
        img.src = canvasImg.toDataURL('image/png'); // 将canvas对象转换为图片的data url
        // const downLink = document.getElementById('down_link');
        // downLink.href = img.src;
        // downLink.download = '二维码'; // 图片name
        this.setState({ qrCodeImg: img });
    };

    render() {
        let { basicInfo, doc, print } = this.state;
        console.log("doc", doc)
        const QRCodeValue = doc.appNo + " " + doc.userTel + " " + doc.productType;
        let address = "";
        if (doc.userProvince) {
            address += I18n.t(doc.userProvince);
        }
        if (doc.userCity) {
            address += I18n.t(doc.userCity);
        }
        if (doc.userAddress) {
            address += doc.userAddress;
        }
        return (
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100vw" }}>
                <div style={{ height: "calc(100vh - 40px)", overflowY: "auto", width: "100%", fontSize: 13, }}>
                    <Form layout="horizontal"
                        id="FixAppPrintForm"
                        className="editForm"
                        ref={comp => this.formRef = comp}
                        style={{
                            backgroundColor: "#FFF",
                            padding: "15px 10px",
                            width: 800,
                            marginLeft: "calc(50vw - 400px)",
                            fontSize: 12,
                        }}
                        onFieldsChange={this.onFieldsChange}
                    >
                        <div style={{ padding: 1, marginBottom: 3, }}>
                            <Row style={{ display: "flex", marginBottom: 5 }}>
                                <Col span={20} style={{ flex: 1 }}>
                                    <Row style={Styles.rowStyle}>
                                        <div style={{ flex: 1 }}>
                                            <div style={{ fontSize: print ? 15 : 22 }}>{basicInfo.logo1}</div>
                                            <div style={{ fontSize: print ? 10 : 12 }}>{basicInfo.address}</div>
                                            <img src={Logo} width={print ? 110 : 160} />
                                        </div>
                                        <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                                            <div style={{ fontSize: print ? 19 : 23, fontWeight: "bold" }}>{basicInfo.titleCN}</div>
                                            <div style={{ fontSize: print ? 15 : 18, fontWeight: "bold" }}>{basicInfo.titleEN}</div>
                                        </div>
                                    </Row>
                                    <div style={{ fontSize: print ? 10 : 12, lineHeight: print ? "14px" : "17px", marginTop: 1 }}>
                                        服務中心辦公時間:   星期一至五 11:00-20:00 / 星期六 11:00-15:00
                                    </div>
                                    <div style={{ fontSize: print ? 10 : 12, lineHeight: print ? "14px" : "17px" }}>
                                        Service Centre Office Hour: Mon to Fri 11:00-20:00 / Sat 11:00-15:00
                                    </div>
                                </Col>
                                <Col span={4} style={{ width: 150, display: "flex", justifyContent: "center", alignItems: "center", }}>
                                    {this.state.print ?
                                        <img src={this.state.qrCodeImg.src} width={70} />
                                        :
                                        <QRCode id="qrCode" value={QRCodeValue} size={100} />
                                    }
                                </Col>
                            </Row>
                            <Row style={{ ...Styles.rowStyle, marginBottom: 3 }}>
                                <Col span={14} style={{ flex: 1 }}>
                                    <div style={{ fontSize: print ? 10 : 12, lineHeight: print ? "14px" : "17px", display: "flex" }}>
                                        客服熱線 Customer Care Hotline: {basicInfo.customerCareHotline}
                                    </div>
                                    <div style={{ fontSize: print ? 10 : 12, lineHeight: print ? "14px" : "17px", display: "flex" }}>
                                        <div style={{ width: 90 }}>辦公時間: </div>
                                        {basicInfo.officeHoursCN}
                                    </div>
                                    <div style={{ fontSize: print ? 10 : 12, lineHeight: print ? "14px" : "17px", display: "flex" }}>
                                        <div style={{ width: 90 }}>Office Hour: </div>
                                        {basicInfo.officeHoursEN}
                                    </div>
                                </Col>
                                <Col span={10} style={{ flex: 1 }}>
                                    <div style={{ fontSize: print ? 10 : 12, lineHeight: print ? "14px" : "17px", display: "flex" }}>
                                        <div style={{ width: 120 }}>系統單號 Ref No: </div>{doc.appNo}
                                    </div>
                                    <div style={{ fontSize: print ? 10 : 12, lineHeight: print ? "14px" : "17px", display: "flex" }}>
                                        <div style={{ width: 120 }}>日期 Date:</div>{this.onDateFormat(global.getDate(doc.createDate), dateTimeFormat)}
                                    </div>
                                </Col>
                            </Row>
                            <div style={{ border: "2px solid #333" }}>
                                <div style={Styles.contentItemStyle}>
                                    <div style={print ? Styles.contentItemTitle2 : Styles.contentItemTitle}>
                                        客戶資料 Customer  Record
                                        {/* <span style={{ fontWeight: "normal", marginLeft: 5 }}>Customer  Record</span> */}
                                    </div>
                                    <div style={Styles.rowStyle}>
                                        <div style={Styles.itemStyle}>
                                            <div style={print ? Styles.itemText2 : Styles.itemText}>姓名 Name:</div>
                                            <div style={print ? Styles.itemContent2 : Styles.itemContent}>{doc.userName}</div>
                                        </div>
                                        <div style={Styles.itemStyle}>
                                            <div style={print ? Styles.itemText2 : Styles.itemText}>電話 Tel:</div>
                                            <div style={print ? Styles.itemContent2 : Styles.itemContent}>{doc.userTel}</div>
                                        </div>
                                    </div>
                                    <div style={Styles.itemStyle}>
                                        <div style={print ? Styles.itemText2 : Styles.itemText}>地址 Address:</div>
                                        <div style={print ? Styles.itemContent2 : Styles.itemContent}>
                                            {/* <Input.TextArea value={address} bordered={false} style={{ width: "100%", border: "none" }} /> */}
                                            {I18n.t(doc.userProvince)}{I18n.t(doc.userCity)}{doc.userAddress}
                                        </div>
                                    </div>
                                </div>
                                <div style={Styles.contentItemStyle}>
                                    <div style={print ? Styles.contentItemTitle2 : Styles.contentItemTitle}>產品資料 Product Description</div>
                                    <div style={Styles.rowStyle}>
                                        <div style={Styles.itemStyle}>
                                            <div style={print ? Styles.itemText2 : Styles.itemText}>型號 Model:</div>
                                            <div style={print ? Styles.itemContent2 : Styles.itemContent}>{doc.productType}</div>
                                        </div>
                                        <div style={Styles.itemStyle}>
                                            <div style={print ? Styles.itemText2 : Styles.itemText}>品牌 Brand:</div>
                                            <div style={print ? Styles.itemContent2 : Styles.itemContent}>{doc.brand ? ModelManager.brandArr[doc.brand] : null}</div>
                                        </div>
                                    </div>
                                    <div style={Styles.rowStyle}>
                                        <div style={Styles.itemStyle}>
                                            <div style={print ? Styles.itemText2 : Styles.itemText}>保修情況 Warranty:</div>
                                            <div style={print ? Styles.itemContent2 : Styles.itemContent}>{(doc.noGuarantee || doc.warranty === 2) ? I18n.t("过保") : I18n.t("保修内")}</div>
                                        </div>
                                        <div style={Styles.itemStyle}>
                                            <div style={print ? Styles.itemText2 : Styles.itemText}>購買日期:</div>
                                            <div style={print ? Styles.itemContent2 : Styles.itemContent}>{this.onDateFormat(global.getDate(doc.guaranteeBuyDate), dateFormat)}</div>
                                        </div>
                                    </div>
                                </div>
                                <div style={{ ...Styles.contentItemStyle, display: "flex" }}>
                                    <div style={Styles.itemStyle2}>
                                        <div style={print ? Styles.itemText2 : Styles.itemText}>故障情況 Service Report:</div>
                                        <div style={print ? Styles.itemContent2 : Styles.itemContent}>{doc.description}</div>
                                    </div>
                                    <div style={Styles.itemStyle2}>
                                        <div style={{ padding: "3px 0" }}>
                                            <div style={print ? Styles.itemText2 : Styles.itemText}>隨機附件 Attachment sent together:</div>
                                            <div style={print ? Styles.itemContent2 : Styles.itemContent}>{doc.accessories}</div>
                                        </div>
                                        <div style={{ ...Styles.itemStyle, padding: "3px 0" }}>
                                            <div style={print ? Styles.itemText2 : Styles.itemText}>機身狀況 Scratch: </div>
                                            <div style={print ? Styles.itemContent2 : Styles.itemContent}>是 Yes / 否 No</div>
                                        </div>
                                    </div>
                                </div>
                                <div style={{ ...Styles.contentItemStyle, display: "flex" }}>
                                    <div style={Styles.itemStyle}>
                                        <div style={print ? Styles.itemText2 : Styles.itemText}>檢查費 Inspection Fee:</div>
                                        <div style={print ? Styles.itemContent2 : Styles.itemContent}>{(doc.noGuarantee || doc.warranty === 2) ? doc.fixFee : I18n.t("免费")}</div>
                                    </div>
                                    <div style={Styles.itemStyle} />
                                </div>
                                <div style={Styles.contentItemStyle}>
                                    <div style={print ? Styles.contentItemTitle2 : Styles.contentItemTitle}>維修報告 Service Report</div>
                                    {/* <div style={Styles.rowStyle}> */}
                                    <div style={{ ...Styles.itemStyle, marginBottom: 5 }}>
                                        <div style={Styles.itemText}>維修紀錄:</div>
                                        <div style={print ? Styles.itemContent2 : Styles.itemContent}>{doc.fixRecord}</div>
                                    </div>
                                    {/* <div style={Styles.itemStyle}>
                                            <div style={print ? Styles.itemText2 : Styles.itemText}>零件費用 Spare Parts Cost:</div>
                                            <div style={print ? Styles.itemContent2 : Styles.itemContent}>{(doc.noGuarantee || doc.warranty === 2) ? this.PartsMoney() : I18n.t("免费")}</div>
                                        </div> */}
                                    {/* </div> */}
                                    {/* <div style={Styles.rowStyle}> */}
                                    {/* <div style={Styles.itemStyle}>
                                        <div style={print ? Styles.itemText2 : Styles.itemText}>日期 Date:</div>
                                        <div style={print ? Styles.itemContent2 : Styles.itemContent}>{this.onDateFormat(global.getDate(doc.noticeDate), dateTimeFormat)}</div>
                                    </div> */}
                                    <div style={Styles.itemStyle3}>
                                        <div style={{ ...Styles.itemText4, textAlign: "center", fontSize: print ? 12 : 14 }}>收費 Charges</div>
                                        <div style={{ ...Styles.itemContent3, fontSize: print ? 12 : 14 }}>HK$</div>
                                    </div>
                                    <div style={Styles.itemStyle3}>
                                        <div style={print ? Styles.itemText5 : Styles.itemText4}>檢查費 Inspection Fee</div>
                                        <div style={{ ...Styles.itemContent3, fontSize: print ? 12 : 14 }}>{(doc.noGuarantee || doc.warranty === 2) ? this.setCount(doc.fixFee) : I18n.t("免费")}</div>
                                    </div>
                                    <div style={Styles.itemStyle3}>
                                        <div style={print ? Styles.itemText5 : Styles.itemText4}>零件費 Spare Parts Fee</div>
                                        <div style={{ ...Styles.itemContent3, fontSize: print ? 12 : 14 }}>{(doc.noGuarantee || doc.warranty === 2) ? this.PartsMoney() : I18n.t("免费")}</div>
                                    </div>
                                    <div style={Styles.itemStyle3}>
                                        <div style={print ? Styles.itemText5 : Styles.itemText4}>其他費用 Other Charges</div>
                                        {/* <div style={{ ...Styles.itemContent3, fontSize: print ? 12 : 14 }}>{(doc.noGuarantee || doc.warranty === 2) ? doc.otherFee : I18n.t("免费")}</div> */}
                                        <div style={{ ...Styles.itemContent3, fontSize: print ? 12 : 14 }}>{doc.otherFee != null ? this.setCount(doc.otherFee) : this.setCount(0)}</div>
                                    </div>
                                    <div style={Styles.itemStyle3}>
                                        <div style={print ? Styles.itemText5 : Styles.itemText4}>總價 Total</div>
                                        {/* <div style={{ ...Styles.itemContent4, fontSize: print ? 12 : 14, paddingTop: 2, paddingBottom: 2 }}>{(doc.noGuarantee || doc.warranty === 2) ? this.TotalMoney() : I18n.t("免费")}</div> */}
                                        <div style={{ ...Styles.itemContent4, fontSize: print ? 12 : 14, paddingTop: 2, paddingBottom: 2 }}>{this.TotalMoney()}</div>
                                    </div>
                                    <div style={Styles.itemStyle3}>
                                        <div style={{ flex: 1 }} />
                                        <div style={{ minWidth: 80, height: 1, backgroundColor: "#333" }} />
                                    </div>
                                    {/* </div> */}
                                </div>
                                <div style={{ ...Styles.contentItemStyle, display: "flex" }}>
                                    <div style={Styles.itemStyle2}>
                                        <div style={print ? Styles.itemText2 : Styles.itemText}>客人領回產品 Good Received by:</div>
                                        <div style={{ ...print ? Styles.itemContent2 : Styles.itemContent, height: 35 }} />
                                    </div>
                                    <div style={Styles.itemStyle2}>
                                        <div style={print ? Styles.itemText2 : Styles.itemText}>日期:</div>
                                        <div style={{ ...print ? Styles.itemContent2 : Styles.itemContent, height: 35 }} />
                                    </div>
                                </div>
                                <div style={{ padding: "4px 10px" }}>
                                    <div style={print ? Styles.contentItemTitle2 : Styles.contentItemTitle}>服務細節 Terms and Condition:</div>
                                    {basicInfo.TermsAndCondition.map((tItem) => {
                                        return (
                                            <div key={"tItem" + tItem.No} style={{ padding: "0px 15px", display: "flex", }}>
                                                <div style={{ marginRight: 5 }}>{tItem.No}.</div>
                                                <div>
                                                    <div style={{ minWidth: 100, fontSize: print ? 11 : 13, lineHeight: print ? "13px" : "17px", paddingRight: 10, }}>{tItem.cn}</div>
                                                    <div style={{ minWidth: 100, fontSize: print ? 11 : 13, lineHeight: print ? "13px" : "17px", paddingRight: 10 }}>{tItem.en}</div>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                    </Form>
                </div >
                <div style={{ position: "fixed", bottom: 0, backgroundColor: "#DDD", textAlign: "right", padding: 3, backgroundImage: "linear-gradient(#EEE, #CCC)" }}>
                    <Button onClick={this.printReport}>{I18n.t("打印")}</Button>
                    <Button onClick={() => this.goBack()}>{I18n.t("返回")}</Button>
                </div>
            </div >
        );
    }
}

const Styles = {
    rowStyle: {
        display: "flex",
    },
    logoText: {
        fontSize: 12
    },
    logoText2: {
        fontSize: 12
    },
    topHalfStyle: {
        flex: 1
    },
    contentItemStyle: {
        // padding: "5px 10px",
        padding: "4px 10px",
        borderBottom: "2px solid #333"
    },
    contentItemTitle: {
        padding: "0 15px",
        fontWeight: "bold",
        fontSize: 13,
    },
    contentItemTitle2: {
        padding: "0 15px",
        fontWeight: "bold",
        fontSize: 12,
    },
    itemStyle: {
        display: "flex",
        flex: 1,
        padding: "2px 15px",
    },
    itemStyle2: {
        flex: 1,
        padding: "2px 15px",
    },
    itemStyle3: {
        display: "flex",
        flex: 1,
        padding: "1px 15px",
    },
    itemText: {
        minWidth: 100,
        paddingRight: 15,
        fontSize: 13,
    },
    itemText2: {
        minWidth: 100,
        paddingRight: 15,
        fontSize: 12,
    },
    itemText3: {
        minWidth: 100,
        paddingRight: 15,
        fontSize: 12,
    },
    itemContent: {
        borderBottom: "1px solid #333",
        flex: 1,
        minHeight: 18,
        lineHeight: "15px",
        fontSize: 13,
    },
    itemContent2: {
        borderBottom: "1px solid #333",
        flex: 1,
        minHeight: 18,
        lineHeight: "15px",
        fontSize: 12,
    },
    textStyle: {
        fontSize: 12,
        lineHeight: "15px",
    },
    textStyle2: {
        fontSize: 10,
        lineHeight: "15px",
    },

    itemText4: {
        minWidth: 100,
        paddingRight: 15,
        fontSize: 14,
        lineHeight: "15px",
        flex: 1,
    },
    itemText5: {
        minWidth: 100,
        paddingRight: 15,
        fontSize: 12,
        lineHeight: "12px",
        flex: 1,
    },
    itemContent3: {
        // borderBottom: "1px solid #333",
        minWidth: 80,
        minHeight: 18,
        lineHeight: "15px",
        fontSize: 13,
        textAlign: "center",
    },
    itemContent4: {
        borderTop: "1px solid #333",
        borderBottom: "1px solid #333",
        minWidth: 80,
        minHeight: 18,
        lineHeight: "12px",
        fontSize: 12,
        textAlign: "center",
        // textDecoration: "underline",
    },
};
